import React, { useState, useEffect } from 'react';
import { Link, useHistory, useRouteMatch } from 'react-router-dom';
import { faMapMarkedAlt, faPlus } from '@fortawesome/free-solid-svg-icons'
import Search from '../../components/Search';
import CircleButton from '../../components/CircleButton';
import useAuth from '../../services/authentication/useAuth';
import FlowDeviceTableRow from '../../components/flowDevices/FlowDeviceTableRow';
import { getAllFlowDevices, deleteFlowDevice } from '../../services/api';

const FlowDevices = () => {
  const [flowDevices, setFlowDevices] = useState([]);
  const [loading, setLoading] = useState(true);
  const { path, url } = useRouteMatch();
  const { companyId } = useAuth();

  useEffect(() => {
    setupFlowDevices();
  }, []);

  const setupFlowDevices = async () => {
    setLoading(true);
    const result = await getAllFlowDevices();
    console.log(result);
    const resultSorted = result.sort((a, b) => a.name <= b.name ? -1 : 1);
    setFlowDevices(resultSorted);
    setLoading(false);
  };

  const onDelete = async id => {
    await deleteFlowDevice(id);
    await setupFlowDevices();
  };

  const rows = flowDevices?.map((flowDevice, index) => <FlowDeviceTableRow key={index} flowDevice={flowDevice} onDelete={onDelete} />);

  return (
    <div id="flowDevices" className="list">
      <h2>Flow Devices</h2>
      {loading ? (
        <div className="spinner"></div>
      ) : (
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Name</th>
              <th>Diameter</th>
              <th>Default Device</th>
              <th className='command-row'>
                <Link to={'flowDevices/add'}>
                  <CircleButton icon={faPlus} type="success" title="Add Flow Device" />
                </Link>
              </th>
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default FlowDevices;